import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { Link } from '~/components'
import { menuBar, navItems } from '~/data'
import * as st from '~/assets/styl/MenuBar.module.styl'
import { useLanguage } from '~/hooks'

export default function MenuBar() {
  const [visible, setVisible] = useState(false)
  const [open, setOpen] = useState(false)
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY >= document.getElementById('Home').offsetHeight)
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
  const { t } = useLanguage()
  return (
    <nav className={cn(st.core, { [st.visible]: visible, [st.open]: open })}>
      <Link href="/#Home"></Link>
      <div className={st.switchLanguage}>
        <a
          href="/dvert-residence/"
          className={
            process.env.GATSBY_LANGUAGE === 'pt' ? st.active : undefined
          }
        >
          PT
        </a>
        <a
          href="/en/dvert-residence/"
          className={
            process.env.GATSBY_LANGUAGE === 'en' ? st.active : undefined
          }
        >
          EN
        </a>
        <a
          href="/es/dvert-residence/"
          className={
            process.env.GATSBY_LANGUAGE === 'es' ? st.active : undefined
          }
        >
          ES
        </a>
      </div>
      {menuBar.map(({ icon, to }, index) => (
        <Link
          href={`/${to}`}
          key={index}
          style={{
            backgroundImage: `url(${icon})`,
          }}
          onClick={() => setOpen(false)}
        >
          <span>{t('MenuBar.items', { returnObjects: true })[index].name}</span>
        </Link>
      ))}
      <button className={st.openBtn} onClick={() => setOpen(!open)}></button>
    </nav>
  )
}
